var _rect, _rect2, _rect3, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 28,
    height: 28,
    rx: 6,
    fill: "url(#paint0_radial_18830_211560)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 28,
    height: 28,
    rx: 6,
    fill: "url(#paint1_radial_18830_211560)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 28,
    height: 28,
    rx: 6,
    fill: "url(#paint2_radial_18830_211560)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 10.5C23.5 11.3284 22.8284 12 22 12C21.1716 12 20.5 11.3284 20.5 10.5C20.5 9.67157 21.1716 9 22 9C22.8284 9 23.5 9.67157 23.5 10.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 21C19.2614 21 21.5 18.7614 21.5 16C21.5 13.2386 19.2614 11 16.5 11C13.7386 11 11.5 13.2386 11.5 16C11.5 18.7614 13.7386 21 16.5 21ZM16.5 19C18.1569 19 19.5 17.6569 19.5 16C19.5 14.3431 18.1569 13 16.5 13C14.8431 13 13.5 14.3431 13.5 16C13.5 17.6569 14.8431 19 16.5 19Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 15.6C6.5 12.2397 6.5 10.5595 7.15396 9.27606C7.7292 8.14708 8.64708 7.2292 9.77606 6.65396C11.0595 6 12.7397 6 16.1 6H16.9C20.2603 6 21.9405 6 23.2239 6.65396C24.3529 7.2292 25.2708 8.14708 25.846 9.27606C26.5 10.5595 26.5 12.2397 26.5 15.6V16.4C26.5 19.7603 26.5 21.4405 25.846 22.7239C25.2708 23.8529 24.3529 24.7708 23.2239 25.346C21.9405 26 20.2603 26 16.9 26H16.1C12.7397 26 11.0595 26 9.77606 25.346C8.64708 24.7708 7.7292 23.8529 7.15396 22.7239C6.5 21.4405 6.5 19.7603 6.5 16.4V15.6ZM16.1 8H16.9C18.6132 8 19.7777 8.00156 20.6779 8.0751C21.5548 8.14674 22.0032 8.27659 22.316 8.43597C23.0686 8.81947 23.6805 9.43139 24.064 10.184C24.2234 10.4968 24.3533 10.9452 24.4249 11.8221C24.4984 12.7223 24.5 13.8868 24.5 15.6V16.4C24.5 18.1132 24.4984 19.2777 24.4249 20.1779C24.3533 21.0548 24.2234 21.5032 24.064 21.816C23.6805 22.5686 23.0686 23.1805 22.316 23.564C22.0032 23.7234 21.5548 23.8533 20.6779 23.9249C19.7777 23.9984 18.6132 24 16.9 24H16.1C14.3868 24 13.2223 23.9984 12.3221 23.9249C11.4452 23.8533 10.9968 23.7234 10.684 23.564C9.93139 23.1805 9.31947 22.5686 8.93597 21.816C8.77659 21.5032 8.64674 21.0548 8.5751 20.1779C8.50156 19.2777 8.5 18.1132 8.5 16.4V15.6C8.5 13.8868 8.50156 12.7223 8.5751 11.8221C8.64674 10.9452 8.77659 10.4968 8.93597 10.184C9.31947 9.43139 9.93139 8.81947 10.684 8.43597C10.9968 8.27659 11.4452 8.14674 12.3221 8.0751C13.2223 8.00156 14.3868 8 16.1 8Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18830_211560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.5 23) rotate(-55.3758) scale(25.5196)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_18830_211560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5 31) rotate(-65.1363) scale(22.5942)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_18830_211560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1 3) rotate(-8.1301) scale(38.8909 8.31836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.164c8d75efd59b72fb642639c7ae3091.svg";
export { ForwardRef as ReactComponent };